import { PEOPLE_TYPES } from './types';
import { getAngularService, AngularServices, } from '../../../../modules/core/helpers/get-angular-service';
const _audioElMap = new Map();
export const playSound = async (sound, speakerDeviceId) => {
    const file = `/assets/sounds/${sound}.mp3`;
    let audioEl = _audioElMap.get(file);
    if (audioEl === undefined) {
        audioEl = new Audio(file);
        audioEl.load();
        audioEl.volume = 0.1;
        _audioElMap.set(file, audioEl);
    }
    if (speakerDeviceId) {
        try {
            const setSinkId = getAngularService(AngularServices.SetSinkId);
            if (setSinkId.isSupported) {
                await setSinkId(audioEl, speakerDeviceId);
            }
        }
        catch (error) {
            console.warn('Failed to set audio output device:', error);
            // Continue playing on default device if setSinkId fails
        }
    }
    return audioEl.play().catch(() => {
        // VM 18/02/20
        // Suppress these errors because 99% of the time they happen due to
        // browser blocking the autoplay attempts (like, on message), we don't care
    });
};
const shouldPlaySound = (user, rooms, roomId) => {
    const personalRoom = rooms.find((room) => {
        return room.roomMemberships.find((roomMembership) => {
            return (roomMembership.role === 'admin' && roomMembership.userId === user.id);
        });
    });
    const shouldPlaySoundBasedOnNotificationRoomType = user.notificationRoomType === 'all' ||
        (user.notificationRoomType === 'personal' && personalRoom.id === roomId) ||
        (user.notificationRoomType === 'shared' && personalRoom.id !== roomId);
    return (Boolean(user) &&
        user.browserNotifications &&
        Boolean(user.soundNotification) &&
        shouldPlaySoundBasedOnNotificationRoomType);
};
const _alreadyPlayedMap = new Map();
export const playAddPersonSound = (person, user, rooms) => {
    if (!_alreadyPlayedMap.get(person.uuid) &&
        person.type === PEOPLE_TYPES.patient &&
        shouldPlaySound(user, rooms, person.roomId)) {
        _alreadyPlayedMap.set(person.uuid, true);
        void playSound(user.soundNotification);
        return true;
    }
    return false;
};
